export const LIGHT_GREY = '#d9d9d9';
export const GREEN_SHADE_60 = '#7ab8b6';
export const GREEN_SHADE_42 = '#4b8b89';
